import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeConvert'
})
export class TimeConvertPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const match = value.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return value;

    let [_, hourStr, minutes, period] = match;
    let hour = parseInt(hourStr, 10);

    // ✅ Special case: 12:00 AM → 23:59:00
    if (period.toUpperCase() === 'AM' && hour === 12 && minutes === '00') {
      return '23:59:00';
    }

    if (period.toUpperCase() === 'PM' && hour < 12) {
      hour += 12;
    } else if (period.toUpperCase() === 'AM' && hour === 12) {
      hour = 0;
    }

    const hourFormatted = hour.toString().padStart(2, '0');
    return `${hourFormatted}:${minutes}:00`;
  }
}
